import { useEffect, useRef, useState } from 'react';
import { Button, ErrorText, Text } from '../../../components/SecondaryMarket';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import icons from '../../../constants/icons';
import { ReactSVG } from 'react-svg';
import ViewItems from '../../../components/ViewItems';
import ViewReverse from '../../../components/ViewReverse';
import { cn, formatNumbers, getContentKeyAccToLang, showToast } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { deleteKycDocument, downloadKycDocument, getCorporateKycData, getDocument, uploadKycDocument } from '../../../store/actions/corporate-action';
import { downloadBase64File, getRejectedFieldData } from '../../../utils/functions';
import { deleteAccountOpeningDocument, downloadAccountOpeningDocument, fetchAccountOpeningDocument, getAccountOpeningForm, uploadAccountOpeningDocument } from '../../../store/actions/accountOpeningAction';

const MAX_FILE_SIZE = 2 * 1024 * 1024;
const ACCEPTED_FILE_TYPES = ['.pdf', '.jpg', '.jpeg', '.png', 'pdf', 'jpg', 'jpeg', 'png'];
const ACCEPTED_FILE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];

const DocumentUpload = ({ isKYC, isOpen = true, setStep, contentKey, percentage }) => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();
  const { corporate_loading } = useSelector((state) => state.corporate);

  const fileInputRef = useRef(null);

  const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const corpKycContent = useSelector((state) => state.content?.corpKycContent);
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);
  const applicationId = useSelector((state) => state.content?.applicationId);
  const { corporate_kyc_data, rejection_summary, is_rejected, field_codes, is_qualified } = useSelector((state) => state.corporate);
  const accountOpeningData = useSelector((state) => state.content?.accountOpeningData);
  const dashboardContent = useSelector((state) => state.content?.dashboardContent);
  const getCommonContentKey = (key) => getContentKeyAccToLang(dashboardContent, key, isArabic);

  const getContentKey = (key) => {
    const content = isKYC ? corpKycContent : corpAOContent;
    return getContentKeyAccToLang(content?.[contentKey]?.data?.attributes, key, isArabic);
  };

  const rejectedFields = rejection_summary?.find(item => item?.sectionId === 8)?.rejectedFields || [];

  const handleUploadDocument = (documentTypeId, droppedFile = null) => {

    setSelectedDocumentTypeId(documentTypeId);

    // ✅ Drag & drop flow
    if (droppedFile) {
      const fakeEvent = {
        target: {
          files: [droppedFile],
        },
      };

      handleFileChange(fakeEvent);
      return;
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event?.target?.files?.[0];

    if (!selectedFile || !selectedDocumentTypeId) {
      return;
    }

    const extension = selectedFile?.name?.split('.')?.pop()?.toLowerCase();

    if (!ACCEPTED_FILE_EXTENSIONS.includes(extension)) {
      showToast({
        icon: 'error',
        title: getCommonContentKey('file_type_error'),
      });
      return;
    }

    if (selectedFile.size > MAX_FILE_SIZE) {
      showToast({
        icon: 'error',
        title: getCommonContentKey('file_size_2mb_error'),
      });
      return;
    }

    const formData = new FormData();
    const application_id = isKYC ? applicationId : applicationId
    formData.append('clientApplicationId', application_id);
    formData.append('documentTypeId', selectedDocumentTypeId);
    formData.append('document', selectedFile);
    formData.append('languageId', isArabic ? 2 : 1);

    isKYC ? (
      dispatch(uploadKycDocument(formData, () => {
        dispatch(getCorporateKycData(application_id));
      }))
    ) : (
      dispatch(uploadAccountOpeningDocument(formData, () => {
        dispatch(getAccountOpeningForm(isArabic ? 2 : 1))
      }))
    )

  };

  const handleDeleteDocument = (documentTypeId) => {

    isKYC ? (
      dispatch(deleteKycDocument(documentTypeId, () => (
        dispatch(getCorporateKycData(applicationId))
      )))
    ) : (
      dispatch(
        deleteAccountOpeningDocument({ documentPayloadId: documentTypeId, languageId: isArabic ? 2 : 1 }, () => (
          dispatch(getAccountOpeningForm(isArabic ? 2 : 1))
        ))
      )
    )
  }
  const handleDownloadDocument = (documentTypeId) => {
    isKYC ? (
      dispatch(downloadKycDocument(documentTypeId))
    ) : (
      dispatch(downloadAccountOpeningDocument({ payloadId: documentTypeId, languageId: isArabic ? 2 : 1 }))
    )
  }
  const fetchDocument = () => {
    isKYC ? (
      dispatch(getDocument((response) => {
        const base64Data = response?.result?.base64Content
        const fileName = response?.result?.fileName
        const type = response?.result?.contentType
        downloadBase64File({ base64Data, fileName, type })
      }))
    ) : (
      dispatch(fetchAccountOpeningDocument(isArabic ? 2 : 1, (response) => {
        const base64Data = response?.result?.base64Content
        const fileName = response?.result?.fileName
        const type = response?.result?.contentType
        downloadBase64File({ base64Data, fileName, type })
      }))
    )
  }
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (!files || files.length === 0) return;

    // take first file (you can extend for multiple)
    const file = files[0];
    // pass file to your upload handler
    handleUploadDocument(fatca_doc?.documentTypeId, file);
  };

  const handleDragEnter = (documentTypeId) => (e) => {
    e.preventDefault();
    setSelectedDocumentTypeId(documentTypeId);
    setIsDragging(true);
  };

  const fatca_doc = corporate_kyc_data?.formDocuments?.find((doc) => doc?.documentTypeId === 1150)
  const documents_list = corporate_kyc_data?.formDocuments?.filter(doc => is_qualified ? true : (doc?.documentTypeId !== 1151 && doc?.documentTypeId !== 1157)) || [];
console.log("documents_list",documents_list)
  return (
    <div>
      <input ref={fileInputRef} type='file' className='hidden' accept={ACCEPTED_FILE_TYPES.join(',')} onChange={handleFileChange} />

      <ViewReverse className={cn('w-full items-center gap-2 justify-between', isKYC && 'cursor-pointer')} onClick={() => isKYC && setStep(6)}>
        <ViewReverse className="flex items-center gap-2">
          <Text text={getContentKey('document_upload')} weight={TextWeight.headingRegular} className={'text-dark-blue'} size={fontSizes.h30} />
          {rejectedFields?.length > 0 && <ReactSVG src={icons.heading_info_outline_icon} />}
        </ViewReverse>

        <ViewReverse className={'items-center gap-2'}>
          <Text text={`${formatNumbers(percentage) ?? 0}%`} className={'text-dark-blue'} size={fontSizes.h14} />
          {isKYC && <ReactSVG src={icons.downArrow} className={cn(isOpen ? 'rotate-180' : 'rotate-0')} />}
        </ViewReverse>
      </ViewReverse>

      {isOpen && (
        <>
          <ViewItems className='mt-7 bg-light-background p-5 rounded-xl w-full space-y-6'>
            <Text text={getContentKey('required_documents')} weight={TextWeight.bold} isRequired size={fontSizes.h12} className={'py-2'} />

            {
              documents_list?.map((item) => {

                const rejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes?.documents, item?.documentTypeId);
                return (
                  (item?.documentTypeId !== 1150 || item?.documentPayloadId) && (
                    <ViewItems key={item?.documentTypeId} className='w-full gap-2'>
                      <ViewReverse className='justify-between md:items-center gap-2 w-full' isResponsive>
                        <ViewItems>
                          <Text
                            text={item?.documentTypeName}
                            size={fontSizes.h14}
                            className={rejectedField?.remarks?.length > 0 ? 'text-red-600' : 'text-dark-grey'}
                            isRequired={item?.isMandatory}
                            isEmpty={Boolean(item?.isMandatory) && !item?.documentPayloadId}
                          />
                          <Text text={item?.documentName} size={fontSizes.h12} />
                          {
                            rejectedField?.remarks?.length > 0 && (
                              <ViewReverse className='flex items-end gap-2'>
                                <ReactSVG src={icons.field_info_outline} />
                                <ErrorText text={rejectedField?.remarks} />
                              </ViewReverse>
                            )
                          }
                        </ViewItems>
                        <ViewReverse className='gap-2'>
                          {
                            item?.documentPayloadId && (
                              <Button
                                text={getContentKey('download')}
                                className={'bg-dark-blue border-dark-blue'}
                                weight={TextWeight.bold}
                                textSize={fontSizes.h14}
                                isDisabled={corporate_loading}
                                onClick={() => handleDownloadDocument(item?.documentPayloadId)}
                              />
                            )
                          }
                          <Button
                            text={getContentKey(item?.documentPayloadId ? 'delete' : 'upload')}
                            className={'border border-dashed border-grey bg-white text-dark-blue min-w-[90px]'}
                            weight={TextWeight.bold}
                            textSize={fontSizes.h14}
                            isDisabled={(is_rejected && !rejectedField?.remarks) || corporate_loading}
                            onClick={() => item?.documentPayloadId ? handleDeleteDocument(item?.documentPayloadId) : handleUploadDocument(item?.documentTypeId)}
                          />
                        </ViewReverse>
                      </ViewReverse>
                    </ViewItems>
                  )
                )
              })
            }
          </ViewItems>

          {
            !fatca_doc?.documentPayloadId && (
              <div className='mt-10 bg-light-background p-5 rounded-xl'>
                <ViewReverse className='py-2 justify-between items-center gap-2' isResponsive>
                  <ViewItems>
                    <Text text={fatca_doc?.documentTypeName} size={fontSizes.h18} />
                    <Text text={getContentKey('please_download')} size={fontSizes.h12} className={'text-text-grey'} />
                  </ViewItems>
                  <Button
                    icon={icons.download_grey_icon}
                    text={getContentKey('download_form')}
                    onClick={fetchDocument}
                    className={'w-full md:w-fit bg-white border border-grey text-dark-blue'}
                    weight={TextWeight.bold}
                    textSize={fontSizes.h14}
                    isDisabled={corporate_loading}
                  />
                </ViewReverse>
                <div onClick={() => handleUploadDocument(fatca_doc?.documentTypeId)}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onDragEnter={handleDragEnter(fatca_doc?.documentTypeId)}
                  className='cursor-pointer'>
                  <ViewItems className='mt-2 bg-white border border-dashed w-full p-6 rounded-xl items-center'
                  >
                    <ReactSVG src={icons.upload_icon} className='mb-4' />
                    <Text text={getContentKey('upload_or_drag_drop')} className={'text-dark-blue'} weight={TextWeight.bold} size={fontSizes.h14} />
                    <Text text={fatca_doc?.documentName ? fatca_doc?.documentName : getContentKey("image_or_pdf_max")} className={'text-dark-grey/50'} size={fontSizes.h14} />
                  </ViewItems>
                </div>
              </div>
            )
          }
        </>
      )}
    </div>
  );
};

export default DocumentUpload;
